import React from 'react';
import { getLanguage } from '@deadpan/shared';
import { useTranslations } from '../hooks/useTranslations';
import { WeekendHahaSignup } from './WeekendHahaSignup';

interface WeekendHahaPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WeekendHahaPanel: React.FC<WeekendHahaPanelProps> = ({ isOpen, onClose }) => {
  const t = useTranslations();
  const title = t.ui.weekendHahaTab ?? (getLanguage() === 'zh' ? '周末有嘻嘻哈哈' : 'Weekend hangout');

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-[120] bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />
      <div
        className="fixed inset-0 z-[120] flex items-center justify-center p-2 sm:p-4"
        role="dialog"
        aria-label={title}
      >
        <div
          className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-[600px] max-h-[95vh] sm:max-h-[90vh] overflow-y-auto border-2 border-indigo-200"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="sticky top-0 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 p-4 sm:p-6 flex items-center justify-between rounded-t-2xl z-10">
            <h2 className="text-xl sm:text-2xl font-bold text-white">{title}</h2>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 text-xl sm:text-2xl font-bold w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full hover:bg-white/20 transition-all"
              aria-label={t.ui.cancel}
            >
              ×
            </button>
          </div>
          <div className="p-4 sm:p-6">
            <WeekendHahaSignup />
          </div>
        </div>
      </div>
    </>
  );
};
